







import Vue, { PropType } from "vue";
import {
  ErrorResponse,
  PostPauseContractResumeRequest,
  PostPauseContractResumeResponse
} from "@/containers/pauseContract/api";
import log from "loglevel";
import VcProgressBar from "@/components/ProgressBar/ProgressBar.vue";

export default Vue.extend({
  name: "vc-pause-resume",
  components: { VcProgressBar },
  props: {
    waitingTime: {
      type: Number,
      default: 0
    },
    contractNumber: {
      type: String,
      default: ""
    },
    paymentType: {
      type: String as PropType<"card" | "billing">,
      default: "card"
    },
    completeUrl: {
      type: String,
      default: ""
    },
    applicationSuccessUrl: {
      type: String,
      default: ""
    },
    sendInvoiceUrl: {
      type: String,
      default: ""
    },
    errorUrl: {
      type: String,
      default: ""
    },
    // actionsToProps
    pauseContractResume: {
      type: Function as PropType<
        (
          req: PostPauseContractResumeRequest
        ) => Promise<PostPauseContractResumeResponse | ErrorResponse>
      >,
      default: () => null
    }
  },
  data() {
    return {
      isComplete: false
    };
  },
  async mounted() {
    try {
      const res = await this.pauseContractResume({
        contractNumber: this.contractNumber
      });
      if (res?.status === "success") {
        this.isComplete = true;
        if (this.paymentType === "billing") {
          window.location.href = this.sendInvoiceUrl;
        } else if ("isPaid" in res && res.isPaid) {
          window.location.href = this.completeUrl;
        } else {
          window.location.href = this.applicationSuccessUrl;
        }
        return;
      } else if (res) {
        const url = new URL(this.errorUrl);
        const params = {
          messageType: "messageType" in res ? res.messageType : null,
          errorCode: "errorCode" in res ? res.errorCode : null
        };
        Object.entries(params).forEach(([key, value]) => {
          if (value) url.searchParams.set(key, value);
        });
        window.location.href = url.toString();
        return;
      }
    } catch (e) {
      log.error(e);
    }
    window.location.href = this.errorUrl;
  }
});
